import { render, staticRenderFns } from "./LotsReport.vue?vue&type=template&id=6166643f&"
import script from "./LotsReport.vue?vue&type=script&lang=js&"
export * from "./LotsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports